import React, { useState } from 'react';
import { MdPerson, MdPhone, MdLocationOn, MdApartment, MdBusiness, MdSend } from "react-icons/md";
import { db } from "../firebase/firebaseConfig"; // Caminho do seu arquivo Firebase config
import { collection, addDoc, query, where, getDocs, serverTimestamp } from "firebase/firestore";
import "../styles/ContactForm.css";

const getUserIP = async () => {
  try {
    const response = await fetch("https://api64.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Erro ao obter IP do usuário:", error);
    return null;
  }
};

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    location: '',
    condos: '',
    towers: ''
  });
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("Verificando...");

    try {
      // Obter IP do usuário
      const userIP = await getUserIP();
      if (!userIP) {
        setMessage("Erro ao validar seu acesso. Tente novamente.");
        return;
      }

      // Verificar se já existe um contato com este IP
      const q = query(collection(db, "contacts"), where("userIP", "==", userIP));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        setMessage("Você já enviou um contato. Aguarde nosso retorno.");
        return;
      }

      // Se não existir, salva no Firestore
      await addDoc(collection(db, "contacts"), {
        ...formData,
        userIP,
        createdAt: serverTimestamp(),
      });

      setMessage("Contato salvo com sucesso!");
      setFormData({ name: "", phone: "", location: "", condos: "", towers: "" });
    } catch (error) {
      setMessage("Erro ao salvar contato. Tente novamente.");
      console.error("Erro ao salvar no Firestore:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="contact-form">
      <label className="contact-label">
        <MdPerson size={24} color="#007bff" />
        <input type='text' name='name' placeholder='Nome' value={formData.name} onChange={handleChange} required />
      </label>
      
      <label className="contact-label">
        <MdPhone size={24} color="#007bff" />
        <input type='tel' name='phone' placeholder='Telefone' value={formData.phone} onChange={handleChange} required />
      </label>
      
      <label className="contact-label">
        <MdLocationOn size={24} color="#007bff" />
        <input type='text' name='location' placeholder='Localização' value={formData.location} onChange={handleChange} required />
      </label>
      
      <label className="contact-label">
        <MdBusiness size={24} color="#007bff" />
        <input type='number' name='condos' placeholder='Quantidade de Condomínios' value={formData.condos} onChange={handleChange} required />
      </label>
      
      <label className="contact-label">
        <MdApartment size={24} color="#007bff" />
        <input type='number' name='towers' placeholder='Quantidade de Torres' value={formData.towers} onChange={handleChange} required />
      </label>
      
      <button type='submit' className="contact-button">
        <MdSend size={24} color="#fff" /> Quero Saber Mais
      </button>
      
      {message && <p className="contact-message">{message}</p>}
    </form>
  );
};

export default ContactForm;
